import { api } from './baseApi';
export var newSchemesApi = api.injectEndpoints({
    endpoints: function (builder) {
        return ({
            getNewSchemesByRestId: builder.query({
                query: function (restaurantId) {
                    return ({
                        url: "/restaurants/newschemes/".concat(restaurantId),
                        method: 'GET',
                    });
                },
                providesTags: ['NewSchemes'],
            }),
            getAllNewSchemes: builder.query({
                query: function () {
                    return ({
                        url: "/restaurants/newschemes",
                        method: 'GET',
                    });
                },
                providesTags: ['NewSchemes'],
            }),
            createNewSchemes: builder.mutation({
                query: function (formData) {
                    return ({
                        url: "/restaurants/upload/newschemes",
                        method: 'POST',
                        body: formData,
                    });
                },
                invalidatesTags: ['NewSchemes'],
            }),
            deleteNewScheme: builder.mutation({
                query: function (id) {
                    return ({
                        url: "/restaurants/newschemes/".concat(id),
                        method: 'DELETE',
                    });
                },
                invalidatesTags: ['NewSchemes'],
            }),
            confirmNewScheme: builder.mutation({
                query: function (schemeId) {
                    return ({
                        url: "/restaurants/newschemes/confirm/".concat(schemeId),
                        method: 'POST',
                    });
                },
                invalidatesTags: ['NewSchemes'],
            }),
            /** Загрузка схем напрямую в карты ресторана (из админки). Не создаёт запись в NewScheme. */
            uploadMapsDirect: builder.mutation({
                query: function (formData) {
                    return ({
                        url: "/restaurants/createMap",
                        method: 'POST',
                        body: formData,
                    });
                },
                invalidatesTags: ['NewSchemes', 'Menu'],
            }),
        });
    },
});
export var useGetNewSchemesByRestIdQuery = newSchemesApi.useGetNewSchemesByRestIdQuery, useGetAllNewSchemesQuery = newSchemesApi.useGetAllNewSchemesQuery, useCreateNewSchemesMutation = newSchemesApi.useCreateNewSchemesMutation, useDeleteNewSchemeMutation = newSchemesApi.useDeleteNewSchemeMutation, useConfirmNewSchemeMutation = newSchemesApi.useConfirmNewSchemeMutation, useUploadMapsDirectMutation = newSchemesApi.useUploadMapsDirectMutation;
